import React, {useState, useEffect} from 'react';
import {IStyleguideRoute} from '../../types/types';
import MenuListLink from './MenuListLink';
import {clsx} from 'clsx';
import {channelMainPageFigmaIds} from '../../stores/consts';
import {useLocation} from 'react-router-dom';

interface IMenuListItemProps {
    route: IStyleguideRoute;
}

/**
 * Раскрывающийся пункт меню.
 */
export const MenuListItem: React.FC<IMenuListItemProps> = ({route}) => {
    const [opened, setOpened] = useState(false);
    const {pathname} = useLocation();
    const pathFromURL = decodeURIComponent(pathname.slice(1));
    const exceptionPages = ['SberBusiness/Медиакит/sberbusiness', 'SberAPI/Медиакит/sber api'];

    const onClickMenuItem = () => {
        if (route.CHILDREN) {
            setOpened(opened => !opened);
        }
    };

    const hasMatchingPath = (routeToCheck: IStyleguideRoute, currentPath: string): boolean => {
        if (exceptionPages.includes(currentPath)) return false;

        if (routeToCheck.FULL_PATH === currentPath) return true;

        if (!routeToCheck.CHILDREN) return false;

        return routeToCheck.CHILDREN.some(child => hasMatchingPath(child, currentPath));
    };

    useEffect(() => {
        const isMatch = hasMatchingPath(route, pathFromURL);
        setOpened(isMatch);
    }, [route, pathFromURL]);

    return (
        <div className="menu-list-item">
            <div className={clsx('menu-list-link')} onClick={onClickMenuItem}>
                <span>{route.NAME}</span>

                {route.CHILDREN && (
                    <div className={clsx('open-icon', { opened: opened })}>
                        <svg
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            stroke="currentColor"
                        >
                            <line x1="5" y1="0" x2="5" y2="10" className="line-vertical" />
                            <line x1="0" y1="5" x2="10" y2="5" className="line-horizontal" />
                        </svg>
                    </div>
                )}
            </div>

            {route.CHILDREN && (
                <div className={clsx('menu-sublist', {'opened': opened, 'closed': !opened,})}>
                    {route.CHILDREN.map((r) => {
                        const { CHILDREN, FULL_PATH, NAME } = r;

                        if (CHILDREN && CHILDREN.length) {
                            return <MenuListItem key={FULL_PATH} route={r} />;
                        }

                        // Титульные страницы раздела в меню не выводятся.
                        if (channelMainPageFigmaIds.includes(r.FIGMA_ID!)) {
                            return null;
                        }

                        return (
                            <div className="menu-list-item" key={FULL_PATH}>
                                <MenuListLink path={FULL_PATH} label={NAME} />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

